/* eslint-disable */

/** select columns of table "plv8_response" */
export enum Plv8ResponseSelectColumn {
  /** column name */
  Id = 'id'
}

/** select columns of table "plv8_value_response" */
export enum Plv8ValueResponseSelectColumn {
  /** column name */
  Value = 'value'
}

